var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-page flex-row flex-center"},[_c('div',[_c('div',{staticStyle:{"text-align":"center","margin-bottom":"10px"}},[_c('van-loading',{attrs:{"size":"44"}})],1),_c('div',[_vm._v("正在登录，请稍候...")])])])}
var staticRenderFns = []

export { render, staticRenderFns }